import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import '@/index.css';
import App from '@/App';

// Suppress ResizeObserver errors - these are benign and don't affect functionality
// They occur when ResizeObserver can't deliver all notifications in a single frame

// Method 1: Override window.onerror
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
    return;
  }
  originalError.apply(console, args);
};

// Method 2: Catch uncaught errors
window.addEventListener('error', e => {
  if (
    e.message &&
    (e.message.includes(
      'ResizeObserver loop completed with undelivered notifications'
    ) ||
      e.message.includes('ResizeObserver loop limit exceeded'))
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Method 3: Debounce ResizeObserver
const debounce = (callback, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback(...args), delay);
  };
};

const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super(debounce(callback, 20));
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
